/**
 * `?scene=1` on the v2 map draws it from the scene (buildScene → SceneRenderer)
 * instead of the layered renderer: the surface for checking the scene against
 * a real map. Without the parameter the wrapped view renders unchanged.
 */
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useInstance } from '../../contexts/InstanceContext';
import SceneView from './SceneRenderer';

export default function withSceneSwitch(View) {
  function SceneSwitch(props) {
    const [searchParams] = useSearchParams();
    const { instanceId } = useInstance();
    if (searchParams.get('scene') !== '1') return <View {...props} />;
    const kid = searchParams.get('kid') || searchParams.get('instance') || searchParams.get('instanceId');
    return <SceneView instanceId={kid || instanceId} />;
  }
  SceneSwitch.displayName = `withSceneSwitch(${View.displayName || View.name || 'View'})`;
  return SceneSwitch;
}
